var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          attrs: { inline: true },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.getDataList()
            },
          },
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.getDataList()
                    },
                  },
                },
                [_vm._v("刷新分组列表")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.reloadConfig()
                    },
                  },
                },
                [_vm._v("重置配置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.clearCache()
                    },
                  },
                },
                [_vm._v("清除缓存")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addOrUpdateHandle()
                    },
                  },
                },
                [_vm._v("新增分组")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.groupList, function (group, index) {
        return _c("config-group-item", {
          key: index,
          attrs: { groupId: group.id, groupInfo: group, formId: _vm.formId },
          on: { refreshDataList: _vm.getDataList },
        })
      }),
      _vm.groupList == undefined || _vm.groupList.length == 0
        ? _c("span", [_vm._v("暂无分组")])
        : _vm._e(),
      _vm.addOrUpdateVisible
        ? _c("add-or-update", {
            ref: "addOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }